import { EditPolicyAssignmentPanelWebComponent } from './component/EditPolicyAssignmentPanelWebComponent';
export { EditPolicyAssignmentPanelWebComponent };
